import { takeLatest, call, select, put } from 'redux-saga/effects'
import {
    SET_CONFERENCE,
    GET_CONFERENCE,
} from '../actions/type'
import {
    getSelector,
    genVRoomToken,
    apiHelper,
} from '../../helpers'
import { getHttpClient } from '../../helpers'
import { isEmpty } from 'lodash'

const keycloakSelector = getSelector('keycloak')

function* getConference({ payload }) {
    const { startDate, endDate } = payload
    let keycloak = yield select(keycloakSelector)
    const url = window._env_.reservation + apiHelper.getConference((Math.floor(startDate / 1000)), (endDate / 1000))
    if (!isEmpty(keycloak) && keycloak.authenticated) {
        try {
            const token = yield call(genVRoomToken, keycloak)
            if (!isEmpty(token)) {
                const { conference, conference_jwt } = yield call(getHttpClient, keycloak, url, { Authorization: "Bearer " + token })
                if (!isEmpty(conference)) {
                    conference.sort((a, b) => {
                        return b.starttime - a.starttime
                    });
                    yield put({
                        type: SET_CONFERENCE,
                        payload: {
                            conferencesList: conference || [],
                            conference_jwt: conference_jwt || '',
                            statusData: 'success'
                        }
                    })
                }
            }
        } catch (err) {
            yield put({
                type: SET_CONFERENCE,
                payload: {
                    statusData: 'fail'
                }
            })
            console.error('getConference', err)
        }
    }
}


function* conferenceSaga() {
    yield takeLatest(GET_CONFERENCE, getConference)
}

export default conferenceSaga
